import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import {
  MARKET_SETTINGS, MARKET_SETTINGS_TYPES, SVG_ICONS,
} from '../../../constants';
import MarketSettingsDropdown from '../../../components/Dropdowns/MarketSettingsDropdown';
import EnableDisableButton from '../../../components/Buttons/EnableDisableButton';

const MarketSettingsTable = (props) => {
  const {
    marketSettings,
    oddsDisabledStatusState,
    resultsDisabledStatusState,
    oddsDropDown,
    toggleOddsDropdownState,
    handleOddsStatus,
    resultsDropDown,
    toggleResultsDropdownState,
    handleResultsStatus,
    checkPermisson,
    toggleDisableOddsStatusState,
    requestForUpdate,
    closeConfirmationBtns,
    toggleDisableResultsStatusState,
    oddsDisableEnableMarketPermission,
    resultsDisableEnableMarketPermission,

  } = props;
  return (
    marketSettings.map((s) => (
      <tr
        key={s.id}
        className={`table-style__row
      ${oddsDisabledStatusState === s.id && 'edit-feed'} 
        ${resultsDisabledStatusState === s.id && 'edit-odds'}`}
      >
        <td>{s.name}</td>
        <td>
          <span className="feed-status">{MARKET_SETTINGS.ODDS[s.oddsDisabled]}</span>
          <MarketSettingsDropdown
            option={s}
            dropdownClass="feed"
            type={MARKET_SETTINGS_TYPES.ODDS}
            dropDown={oddsDropDown}
            toggleDropDown={toggleOddsDropdownState}
            handleStatus={handleOddsStatus}
          />
        </td>

        <td>
          <span className="invalidate-odds">{MARKET_SETTINGS.RESULTS[s.resultsDisabled]}</span>
          <MarketSettingsDropdown
            option={s}
            dropdownClass="odds"
            type={MARKET_SETTINGS_TYPES.RESULTS}
            dropDown={resultsDropDown}
            toggleDropDown={toggleResultsDropdownState}
            handleStatus={handleResultsStatus}
          />
        </td>
        <td>
          <div className="d-flex justify-content-center">

            {checkPermisson(oddsDisableEnableMarketPermission)
              && (
                <EnableDisableButton
                  option={s}
                  classname="feed"
                  handleClick={toggleDisableOddsStatusState}
                  checkAttr1={oddsDisabledStatusState}
                  checkAttr2={resultsDisabledStatusState}
                  type={MARKET_SETTINGS_TYPES.ODDS}
                />
              )}

            <div className="action">
              <div className="action-wrap">
                <div
                  className="action__btn action__btn--approve"
                  onClick={requestForUpdate}
                >
                  <SVGComponent
                    src={`${SVG_ICONS.utility}#tick1`}
                  />
                </div>
                <div
                  className="action__btn action__btn--cancel"
                  onClick={closeConfirmationBtns}
                >
                  <SVGComponent
                    src={`${SVG_ICONS.utility}#close-w`}
                  />
                </div>
              </div>
            </div>

            {checkPermisson(resultsDisableEnableMarketPermission)
              && (
                <EnableDisableButton
                  option={s}
                  classname="odds"
                  handleClick={toggleDisableResultsStatusState}
                  checkAttr1={resultsDisabledStatusState}
                  checkAttr2={oddsDisabledStatusState}
                  type={MARKET_SETTINGS_TYPES.RESULTS}
                />
              )}
          </div>
        </td>

      </tr>
    ))
  );
};

export default MarketSettingsTable;
